import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { cap } from "../../../utils/utils";

function InputTicketTypes({ type, name, value, onChange, required, error }) {
  const { t } = useTranslation();
  const { ticketTypes } = useSelector((state) => state.customerServiceReducer);

  return (
    <div className={`lineInput lineInput${type} lineInput${cap(name)} ${error ? "invalid" : ""}`}>
      <label htmlFor={name}>{t("TYPE")}</label>
      {required && <span className={`${error ? "invalid" : ""}`}>{t("REQUIRED_FIELD")}</span>}
      <select name={name} value={value} onChange={(e) => onChange(e, name)}>
        <option value={""}> {t("SELECT")}</option>
        {ticketTypes?.map(
          (option) =>
            option.active === true && (
              <option key={option[t("INDEX_KEY_STRING")]} value={option.id}>
                {" "}
                {option[t("INDEX_KEY_STRING")]}
              </option>
            ),
        )}
      </select>
    </div>
  );
}

export default InputTicketTypes;
